import styles from "@/styles/login-layout.module.scss"
import React from "react"
import { useEffect } from "react"

import { loadMatomo } from "@/utils/matomo"
import { loadGtm } from "@/utils/gtm"

import Image from 'next/image'
import Link from 'next/link'
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
interface LayoutProps {
  children: React.ReactNode;
  wideScreen?: boolean;  // 是否使用宽屏
  notStickyNavbar?: boolean; // 是否取消Navbar吸顶效果
}

export default function LoginLayout(props: LayoutProps) {
  useEffect(() => {
    function handleWindowLoad() {
      loadMatomo()
      loadGtm();
    }

    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  return (
    <div className={styles['login-layout']}>
      <div className={styles['header']}>
        <Link
          href='/'
          legacyBehavior
        >
          <a rel="noopener noreferrer">
            <Image
              className={styles['site-logo']}
              alt="logo"
              priority={true}
              width={425}
              height={96}
              src={`${imageDomain}/logo.png`} />
          </a>
        </Link>
      </div>

      <main style={{ background: '#fff', minHeight: 'calc(100vh - 268px)', width: 1200, margin: '0 auto' }}>{props.children}</main>

      <div className={styles['footer']}>
        <Link
          href='/article/terms'
          legacyBehavior
        >
          <a className={styles['link']} rel="noopener noreferrer">
            Terms & Conditions
          </a>
        </Link>

        <div className={styles['separate']}></div>

        <Link
          href='/article/privacy'
          legacyBehavior
        >
          <a className={styles['link']} rel="noopener noreferrer">
            Privacy Statement
          </a>
        </Link>

        <div className={styles['separate']}></div>

        <Link
          href='/'
          legacyBehavior
        >
          <a className={styles['link']} rel="noopener noreferrer">
            <Image
              className={styles['site-logo']}
              alt="logo"
              priority={true}
              width={112}
              height={27}
              src="https://img.bestdeals.co.nz/images/easy-layout-Norton.png" />
          </a>
        </Link>

        <div className={styles['separate']}></div>

        <Link
          href='/'
          legacyBehavior
        >
          <Image
            className={styles['site-logo']}
            alt="logo"
            priority={true}
            width={88}
            height={47}
            src="https://img.bestdeals.co.nz/images/easy-layout-comodo.png" />
        </Link>
      </div>
    </div>
  )
}